import configData from "../configs/config.json";

const { REACT_APP_API_URL,REACT_APP_API_URL_LOCAL,REACT_APP_API_URL_DEV } = configData;
let URL = REACT_APP_API_URL;
if(window.location.hostname == 'localhost') {
    URL = REACT_APP_API_URL_LOCAL;
}
if(window.location.hostname == 'devbcrm.bhsgroup.vn') {
    URL = REACT_APP_API_URL_DEV;
}
if(window.location.hostname == 'nt.bcrm.vn') {
    URL = "https://api-nt.bcrm.vn/api/";
}
console.log(URL);

export const URL_LIST_ALL = URL ;